var map = {
	"./avatar1.svg": "9a7b",
	"./avatar3.svg": "5e19",
	"./avatar5.svg": "6da6",
	"./avatar6.svg": "5d82",
	"./avatar7.svg": "9978",
	"./icon-chart.svg": "b517",
	"./icon-grid-active.svg": "ea7e",
	"./icon-grid.svg": "a419",
	"./icon-lightbulb.svg": "f46b",
	"./icon-list-active.svg": "299a",
	"./icon-list.svg": "1354"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "129a";